/* eslint-disable */
import React from "react";

import * as url from "helper/UrlHelper";
import { assetImages } from "constants";

const PatientDetailsCard = ({ patient = {} }) => {
  return (
    <div className="patient-details mt-3 p-3 border border-gray-300 rounded-8 shadow-sm">
      {/* Patient details */}
      <div className="d-flex gap-3">
        <div
          className="avatar rounded-circle overflow-hidden"
          style={{
            width: "60px",
            height: "60px",
          }}
        >
          <img
            className="w-100 h-100 object-fit-cover"
            src={
              patient?.image !== ""
                ? url.SERVER_URL + patient?.image
                : assetImages.defaultUser
            }
            alt="patient"
          />
        </div>
        <div>
          <p className="mb-0">{patient?.label}</p>
          <p className="font-sm text-gray mb-1">
            Patient Email: {patient?.email}
          </p>
        </div>
      </div>
      {/* Calendar details for patient */}
      <div className="contact-info pt-3 border-top border-gray-100 mt-3">
        <p className="fw-semibold mb-2">Information for {patient?.label}</p>
        <p className="font-sm text-gray mb-1">Phone: {patient?.phone}</p>
        <p className="font-sm text-gray mb-1">City: {patient?.city}</p>
        <p className="font-sm text-gray mb-1">State: {patient?.state}</p>
        <p className="font-sm text-gray mb-1">Country: {patient?.country}</p>
      </div>
    </div>
  );
};

export default PatientDetailsCard;
